import { articlesExtend } from "src/scripts/mixin";
import hero from "src/components/hero/hero";

export default (articleid) => {

    const contentcontainer = document.getElementById("site_content");

    fetch(window.apiUrl + "/api/PublicContentApi/find/" + articleid).then(response => response.json()).then(data => {


        articlesExtend(data);

        let r = ``;
        
        
        
        r = hero(data);

        contentcontainer.innerHTML = r;


    });


}
